export default __webpack_public_path__ + "static/Image-Including-More-Rhode-Islanders-3719359574316d6f8b9440ecd832f68e.jpg";